import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useCollections from '../../hooks/useCollections';
import CollectionHeader from '../../components/collections/CollectionHeader';
import CollectionSlug from '../../components/collections/CollectionSlug';
import CollectionLanguages from '../../components/collections/CollectionLanguages';
import CollectionDecks from '../../components/collections/CollectionDecks';
import CollectionOrder from '../../components/collections/CollectionOrder';

const LanguageCollectionPage = () => {
    let { docId } = useParams();
    const {fetchCollectionByDocIdInRealtime} = useCollections();
    const [collection, setCollection] = useState(null);
    const [loading, setLoading] = useState(true);
    const [addLanguagesFromDeckRef, setAddLanguagesFromDeckRef] = useState(null);

    useEffect(()=>{
        let unsubscribe = null;
        const fetchData = async () => {
            setLoading(true);
            unsubscribe = await fetchCollectionByDocIdInRealtime({docId: docId, setCollection:setCollection});
            setLoading(false);
        }
        fetchData();
        return () => {
            if (unsubscribe !== null){
                unsubscribe();
            } 
        }
    }
    ,[docId]);

    return (
        <div className="flex flex-col gap-12">
        {!loading && 
            <>
                {collection &&
                    <>
                    <div className="flex flex-row place-items-center gap-10">
                        <CollectionHeader collection={collection} />
                        <CollectionSlug collection={collection} />
                        <CollectionOrder collection={collection} />
                    </div>
                    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl p-4 md:p-6">
                        <CollectionLanguages 
                            collection={collection} 
                            onLanguagesChange={(refs) => setAddLanguagesFromDeckRef(refs?.addLanguagesFromDeck)}
                        />
                    </div>
                    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl p-4 md:p-6">
                        <CollectionDecks 
                            collection={collection} 
                            onAddLanguagesFromDeck={(deck) => {
                                if (addLanguagesFromDeckRef) {
                                    addLanguagesFromDeckRef(deck);
                                }
                            }}
                        />
                    </div>
                    </>
                }
            </>
        }
    </div>
    )
}

export default LanguageCollectionPage;